import React, { useState } from "react";
import axios from "axios";
import Header from "../components/Header";
import Footer from "../components/Footer";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleForgotPassword = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post("https://www.giffypedia.com/php-api/forgot-password.php", { email }, {
        headers: {
          "Content-Type": "application/json"
        }
      });

      setMessage(res.data.message);
    } catch (err) {
      setMessage("Something went wrong. Please try again later.");
    }
  };

  return (
    <>
      <Header />
       <div className="page-body-container">
      <div className="lg:min-h-[500px] flex items-center justify-center bg-gray-100 p-6">
        <div className="bg-white p-6 rounded shadow-md w-full max-w-md text-center">
          <h2 className="text-2xl font-bold mb-4">Forgot Password</h2>
          <p className="mb-4 text-gray-600">Enter your registered email address</p>
          <form onSubmit={handleForgotPassword}>
            <input
              type="email"
              placeholder="Enter your email"
              className="w-full p-2 border mb-4 rounded"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button
              type="submit"
              className="w-full primarybutton mt-0"
            >
              Submit
            </button>
          </form>
          {message && <p className="mt-4 text-sm text-gray-700">{message}</p>}
        </div>
      </div>
      <Footer />
      </div>
    </>
  );
}

export default ForgotPassword;
